<template>
    <div class="amount_card" :class="isActiveAmount ? 'active_card' : ''" @click="handleCardClick">
         {{ formatCurrency(props.amount as any) }}
        <div v-if="isTopupVisible" class="topPercentage" :class="isActiveAmount ? 'activeLabel' : 'inactiveLabel'">
            <span class="item-span">{{ props.giftRatio }}%</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction';


const props = defineProps({
    amount: {
        type: Number,
    },
    isActiveAmount: {
        type: Boolean,
        default: () => false
    },
    isTopupVisible: {
        type: Boolean,
        default: () => false
    },
    giftRatio: {
        type: Number,
    }
})
const emits = defineEmits(['handleCardClick'])

const handleCardClick = () => {
    emits('handleCardClick')
}

</script>
<style scoped>
.amount_card {
    position: relative;
    border-radius: 5px;
    color: #FFF;
    background-color: rgb(0, 86, 85);
    padding: 12px 10px;
    min-width: 80px;     
    flex: 0 0 auto;
    text-align: center;
    font-size: 20px;
    overflow: hidden;
    font-weight: 700;
}

.active_card {
    font-weight: bold;
    border: 2px solid rgb(13, 176, 174);
    background-image: linear-gradient(180deg,rgba(0,0,0,0) 16.59%,var(--ep-color-background-fill-glow-primary-opacity-40, rgba(58, 140, 227, .4)) 110.34%),var(--ep-color-background-fill-surface-raised-L2, #1A1F30);
    color: #FFFF;

}

.activeLabel {
    background: #046ACC;
    color: #FFFF;
    font-weight: 600;
}

.inactiveLabel {
    background: rgba(0, 0, 0, 0.15);
    color: rgba(255, 255, 255, 0.85);
}

.topPercentage {
    position: absolute;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    width: 55px;
    height: 25px;
    top: 0;
    right: -20px;
    transform: rotate(45deg);
    font-size: 8px;
}

/* @media (min-width: 1440px) {
    .topPercentage {
        margin-left: 4.5vw !important;
    }
}

@media (min-width: 1920px) {
    .topPercentage {
        margin-left: 4.8vw !important;
    }
} */

.item-span {
    top: 10px;
    left: 1px;
}

@media (max-width: 360px) {
  .amount_card {
    font-size: 14px;
    padding: 8px 4px;
    min-width: 60px;
    border-radius: 5px;
  }

  .topPercentage {
    width: 38px;
    height: 18px;
    right: -12px;
    font-size: 6px;
  }

  .item-span {
    font-size: 8px;
  }
}
</style>